import * as ServiceActions from './service.actions';
import { Action, createReducer, on } from '@ngrx/store';

import { KeycodeCheck } from 'src/app/model/keycode-check';
import { PeopleCheck } from 'src/app/model/people-check';

export interface State {
    keycodeChecks: KeycodeCheck[];
    peopleChecks: PeopleCheck[];
    emailOptions: string[];
}

const initialState: State = {
    keycodeChecks: [],
    peopleChecks: [],
    emailOptions: [],
};

const cameServiceReducer = createReducer(
    initialState,
    on(ServiceActions.checkKeycodeSuccess, (state, payload) => ({
        ...state,
        keycodeChecks: [payload.checkResult, ...state.keycodeChecks]
    })),
    on(ServiceActions.checkPeopleSuccess, (state, payload) => ({
        ...state,
        peopleChecks: [payload.checkResult, ...state.peopleChecks]
    })),
    on(ServiceActions.searchEmail, (state) => ({...state, emailOptions: []})),
    on(ServiceActions.searchEmailSuccess, (state, payload) => ({
        ...state,
        emailOptions: payload.emailOptions
    })),
);

export const reducer = (state: State | undefined, action: Action): State => cameServiceReducer(state, action);
